@import url(folder/stylesheet-import1.css);

.rule-direct {
	background: lightgreen;
}
.generated { color: red; }


/** WEBPACK FOOTER **
 ** (webpack)/~/val-loader!./loaders/_css/generateCss.js
 **/